module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1453.90b07c5d.jpg";